import axios from 'axios'

const chatApi = axios.create({
    baseURL: `${process.env.VUE_APP_HOST_CHAT}`
});

export default chatApi